import React, { useContext, useEffect } from 'react';
import { ChartContainer } from './PPAInsightColumnCharts.style';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { AppContext } from '../../../../../Context/AppContext';
import { getVolumeByTechTypeData } from '../../PpaInsightUtils';
import { PPAInsightNoRecords } from '../../PPAInsightNoRecordsPage/PPAInsightNoRecords';

export const PPAInsightColumnChart = () => {
  const { state: ppaInsightState, dispatch: ppaInsightDispatch } =
    useContext(AppContext).ppaInsight;
  useEffect(() => {
    getVolumeByTechTypeData(ppaInsightDispatch, ppaInsightState.filteredValues);
  }, [ppaInsightState.filteredValues]);

  const chartData = ppaInsightState.volumeByTechTypeData.map((item) => ({
    category: item.RENEWABLE_CATEGORY,
    value: item.CAPACITY_EQUIVALENT,
  }));

  return (
    <ChartContainer>
      {ppaInsightState.volumeByTechTypeData.length === 0 && <PPAInsightNoRecords />}
      {ppaInsightState.volumeByTechTypeData.length > 0 && (
        <div style={{ width: '100%', height: '400px' }}>
          <h3 style={{ textAlign: 'left', marginBottom: '0.5rem' }}>PPA Volume by Technology Type</h3>
          <p style={{ textAlign: 'left', fontSize: '0.875rem', color: '#666', marginBottom: '1rem' }}>
            A summary of volume by renewable category
          </p>
          <ResponsiveContainer width="100%" height="80%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="category" />
              <YAxis />
              <Tooltip />
              <Legend verticalAlign="top" height={36} />
              <Bar dataKey="value" fill="#0088FE" name="Renewable Categories" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </ChartContainer>
  );
};
